import React, { useMemo, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  Box,
  TextField,
} from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';

interface TableColumn {
  field: string;
  label: string;
  render?: (value: any, row?: any) => React.ReactNode;
}

interface ExchangeRatesTableProps {
  data: any[];
  columns: TableColumn[];
  onDelete: (item: any) => void;
  onEdit?: (item: any) => void;
}

const ExchangeRatesTable: React.FC<ExchangeRatesTableProps> = ({ data, columns, onDelete, onEdit }) => {
  const [search, setSearch] = useState('');
  const filteredData = useMemo(() => { const needle = search.trim().toLowerCase(); return needle ? data.filter((row) => JSON.stringify(row).toLowerCase().includes(needle)) : data; }, [data, search]);
  return (
    <Box><TextField fullWidth label="Поиск по валюте, трейдеру или курсу" value={search} onChange={(event) => setSearch(event.target.value)} sx={{ mb: 2 }} /><TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.field}>{column.label}</TableCell>
            ))}
            <TableCell align="right">Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredData.map((row) => (
            <TableRow key={row.id}>
              {columns.map((column) => (
                <TableCell key={column.field}>
                  {column.render ? column.render(row[column.field], row) : row[column.field]}
                </TableCell>
              ))}
              <TableCell align="right">
                {onEdit && (
                  <Tooltip title="Edit">
                    <IconButton onClick={() => onEdit(row)}>
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                )}
                <Tooltip title="Удалить">
                  <IconButton onClick={() => onDelete(row)} sx={{ color: '#d32f2f' }}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer></Box>
  );
};

export default ExchangeRatesTable; 
